export enum EditionSelectorType {
  UNIQUE = 'unique',
  EDITIONS = 'editions',
}
